/** Legacy /app/local-album/:key redirect (#916 size gate). */
import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { buildLocalLibraryAlbumUrl } from '../utils/localAlbumNavigation';

export default function LocalAlbumLegacyRedirect() {
  const { key } = useParams();
  const location = useLocation();
  if (!key) {
    return <Navigate to="/app/local-library?tab=albums" replace />;
  }
  return (
    <Navigate
      to={buildLocalLibraryAlbumUrl(key)}
      replace
      state={location.state}
    />
  );
}
